<template>
  <div class="footer-component">
    <p><span class="footer-links"><router-link to="/page/terms-use">Terms of Use</router-link>  / <router-link to="/page/privacy-policy">Privacy Policy</router-link>  / <router-link to="/page/cookie-policy">Cookie Policy</router-link></span>&nbsp;&nbsp;&nbsp;Copyright &copy; {{ year }} OAKE Legal</p>
  </div>
</template>
<script>
	export default{
		data: function (){
			return {
				year: null
			}
		},
		mounted() {
			var d = new Date()
			this.year = d.getFullYear()
		}
	};
</script>
<style scoped>
	.footer-component{
		text-align:left;
		background:#FFF;
		padding:7px 5% 7px !important;
	}

	.footer-component a{
		color:#333;
		margin:0px 5px;
	}

	.spacer{
		height:3px;
		width:3px;
		background:#999;
		display:inline-block;
		margin-right:5px;
		margin-left:5px;
		margin-bottom:1px;
	}

	p{
		font-size:11px;
		color:#333;
		margin-bottom:0;
	}

	p a, .footer-links{
		color:blue !important;
	}

	.footer-links{
		display:inline-block;
		margin-right:10px;
	}
</style>
